// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared modal backdrop */
.ui-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--z-modal-backdrop);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
  background: rgba(15, 15, 30, 0.9);
  backdrop-filter: blur(5px);
  animation: ui-modal-fade-in 0.18s ease-out;
}

/* Dialog chrome, matching the solid Card the app's modals already use.
   variant="bare" emits none of these classes and keeps the caller's own CSS. */
.ui-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 90vh;
  overflow: hidden auto;
  outline: none;
  background: var(--color-dark-lighter);
  border: 1px solid var(--color-dark-light);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  animation: ui-modal-scale-in 0.18s ease-out;
}

.ui-modal--sm {
  max-width: 400px;
}

.ui-modal--md {
  max-width: 500px;
}

.ui-modal--lg {
  max-width: 800px;
}

.ui-modal--full {
  max-width: 95vw;
}

.ui-modal--auto {
  max-width: none;
}

.ui-modal__title {
  margin: 0;
  padding: var(--space-lg) var(--space-lg) 0;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-white);
}

@keyframes ui-modal-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes ui-modal-scale-in {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Respect the OS "reduce motion" setting: show the dialog straight away. */
@media (prefers-reduced-motion: reduce) {

  .ui-modal-overlay,
  .ui-modal {
    animation: none;
  }
}

/* Small screens: keep the dialog clear of notches and home indicators. */
@media (max-width: 600px) {
  .ui-modal-overlay {
    padding: calc(var(--space-md) + env(safe-area-inset-top)) calc(var(--space-md) + env(safe-area-inset-right)) calc(var(--space-md) + env(safe-area-inset-bottom)) calc(var(--space-md) + env(safe-area-inset-left));
  }

  .ui-modal {
    max-height: 88vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/Modal.css"],"names":[],"mappings":"AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;+EAC+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2EAA2E;AAC3E;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,kNAAkN;EACpN;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import '../../styles/variables.css';\n\n/* Shared modal backdrop */\n.ui-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: var(--z-modal-backdrop);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-lg);\n  background: rgba(15, 15, 30, 0.9);\n  backdrop-filter: blur(5px);\n  animation: ui-modal-fade-in 0.18s ease-out;\n}\n\n/* Dialog chrome, matching the solid Card the app's modals already use.\n   variant=\"bare\" emits none of these classes and keeps the caller's own CSS. */\n.ui-modal {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden auto;\n  outline: none;\n  background: var(--color-dark-lighter);\n  border: 1px solid var(--color-dark-light);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  animation: ui-modal-scale-in 0.18s ease-out;\n}\n\n.ui-modal--sm {\n  max-width: 400px;\n}\n\n.ui-modal--md {\n  max-width: 500px;\n}\n\n.ui-modal--lg {\n  max-width: 800px;\n}\n\n.ui-modal--full {\n  max-width: 95vw;\n}\n\n.ui-modal--auto {\n  max-width: none;\n}\n\n.ui-modal__title {\n  margin: 0;\n  padding: var(--space-lg) var(--space-lg) 0;\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-white);\n}\n\n@keyframes ui-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes ui-modal-scale-in {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Respect the OS \"reduce motion\" setting: show the dialog straight away. */\n@media (prefers-reduced-motion: reduce) {\n\n  .ui-modal-overlay,\n  .ui-modal {\n    animation: none;\n  }\n}\n\n/* Small screens: keep the dialog clear of notches and home indicators. */\n@media (max-width: 600px) {\n  .ui-modal-overlay {\n    padding: calc(var(--space-md) + env(safe-area-inset-top)) calc(var(--space-md) + env(safe-area-inset-right)) calc(var(--space-md) + env(safe-area-inset-bottom)) calc(var(--space-md) + env(safe-area-inset-left));\n  }\n\n  .ui-modal {\n    max-height: 88vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
